import getCTAs from "./getCTAs";

const mockResponses = { getCTAs };

export default mockResponses;
